import { Area } from '../../types';
import { convertParsedAddressToArea } from '../address/address';
import { parseSingleAddress } from '../address/singleAddress';
import { doAreasIntersect, isEqualAreas, unionAreas } from '../area/area';

// export const unionAreaWithMerges = (merges: Area[], area: Area) => {
//   merges.forEach((merge) => {
//     if (doAreasIntersect(merge, area)) area = unionAreas(merge, area);
//   });

//   return area;
// };

export const unionAreaWithMerges = (
  merges: Area[], // string[],
  area: Area
  // maxColIndex: number,
  // maxRowIndex: number
): Area => {
  let updatedArea = { start: { ...area.start }, end: { ...area.end } };

  merges.forEach((area) => {
    // const area = convertParsedAddressToArea(
    //   parseSingleAddress(merge),
    //   maxColIndex,
    //   maxRowIndex
    // );
    if (doAreasIntersect(area, updatedArea)) {
      updatedArea = unionAreas(area, updatedArea);
    }
  });

  if (!isEqualAreas(updatedArea, area)) {
    // Recursively call the function with the updated area
    return unionAreaWithMerges(merges, updatedArea);
  }

  return updatedArea;
};
